<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
    title="確認"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-4">
            <div class="modal-body">
              <div class="font-weight-bold mb-3 px-1">
                <div>インターネットType4を変更します。</div>
                <div class="mt-2">
                  下記アプライアンス契約変更の際にセキュリティ監視の変更申込書のご提出が必要です。
                </div>
                <div class="ml-2">・Type4インターネットFW ⇔ UTM</div>
                <div class="ml-2">
                  ・Type4 UTM 1Gbpsベストエフォート ⇔ UTM帯域確保型
                </div>
                <div class="ml-2">
                  ・Type4 UTM帯域確保型10M～1G ⇔ UTM帯域確保型1G～10G
                </div>
                <div class="mt-2">
                  セキュリティアプライアンスを変更する場合はセッション断が発生するため、WVS2カスコンへの再接続が必要です。
                </div>
                <div>よろしいですか？</div>
              </div>
              <!--  インターネットType4        -->
              <v-container fluid class="px-1">
                <v-row>
                  <v-col>
                    <h3>インターネットType4</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col>
                    <app-label-group
                      label="VPN/VNコード"
                      :value="
                        selectedItem.vpnVnCode.charAt(0) !== 'B'
                          ? `${selectedItem.vpnVnCode}(${selectedItem.vnName})`
                          : selectedItem.vpnVnCode
                      "
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group label="回線番号(メイン)">
                      <template #value>
                        <span class="ml-3">
                          {{
                            `${selectedItem.wnumberMainAct}/${selectedItem.wnumberMainSby}`
                          }}
                          [{{
                            $filter.enumTo(selectedItem.mainSite, "mainSite")
                          }}]
                        </span>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group label="回線番号(BCP)">
                      <template #value>
                        <span class="ml-3">
                          {{
                            `${selectedItem.wnumberBcpAct}/${selectedItem.wnumberBcpSby}`
                          }}
                          [{{
                            $filter.enumTo(
                              selectedItem.mainSite === "TOKYO"
                                ? "OSAKA"
                                : "TOKYO",
                              "mainSite"
                            )
                          }}]
                        </span>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="Type4ID"
                      :value="selectedItem.type4Id"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="Type4名"
                      :value="putItem.type4Name"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="メインサイト"
                      :value="$filter.enumTo(selectedItem.mainSite, 'mainSite')"
                    />
                  </v-col>
                </v-row>
                <!--  アプライアンス        -->
                <v-row>
                  <v-col>
                    <h3>アプライアンス</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group label="セキュリティアプライアンス">
                      <template #value>
                        <span class="ml-3">
                          <template v-if="putItem.applianceType === 'IFW'">
                            インターネットFW(100Mbpsベストエフォート)
                          </template>
                          <template
                            v-if="
                              putItem.applianceType === 'UTM' &&
                              putItem.contractType === 'BEST_EFFORT'
                            "
                          >
                            UTM(1Gbpsベストエフォート)
                          </template>
                          <template
                            v-if="
                              putItem.applianceType === 'UTM' &&
                              putItem.contractType === 'SECURING'
                            "
                          >
                            <template v-if="putItem.bandwidth">
                              UTM(帯域確保型
                              {{ putItem.bandwidth.value
                              }}{{
                                $filter.enumTo(
                                  putItem.bandwidth.unit,
                                  "bandwidth_unit"
                                )
                              }})
                            </template>
                          </template>
                        </span>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="4" v-if="user.contractSummary.isSecuritySetting">
                    <app-label-group
                      label="セキュリティ監視オプション"
                      :value="
                        $filter.enumTo(selectedItem.isSecurityOption, 'on_off')
                      "
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group label="インターネット帯域">
                      <template #value>
                        <span class="ml-3">
                          <template v-if="putItem.applianceType === 'IFW'">
                            100Mbpsベストエフォート
                          </template>
                          <template
                            v-if="
                              putItem.applianceType === 'UTM' &&
                              putItem.contractType === 'BEST_EFFORT'
                            "
                          >
                            1Gbpsベストエフォート
                          </template>
                          <template
                            v-if="
                              putItem.applianceType === 'UTM' &&
                              putItem.contractType === 'SECURING'
                            "
                          >
                            <template v-if="putItem.bandwidth">
                              帯域確保型
                              {{ putItem.bandwidth.value
                              }}{{
                                $filter.enumTo(
                                  putItem.bandwidth.unit,
                                  "bandwidth_unit"
                                )
                              }}
                            </template>
                          </template>
                        </span>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group label="デフォルトポリシー">
                      <template #value>
                        <span class="ml-3">
                          <template
                            v-if="
                              putItem.policyType === 'ALLOW_SPECIFIC_ONE_WAY'
                            "
                          >
                            編集可能デフォルトポリシー 片方向(特定サービス)
                          </template>
                          <template
                            v-if="putItem.policyType === 'ALLOW_ALL_ONE_WAY'"
                          >
                            編集可能デフォルトポリシー 片方向(any)
                          </template>
                          <template
                            v-if="putItem.policyType === 'ALLOW_ALL_TWO_WAY'"
                          >
                            編集可能デフォルトポリシー 双方向(any)
                          </template>
                        </span>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--  オプション        -->
                <v-row>
                  <v-col>
                    <h3>オプション</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group label="グローバルIP">
                      <template #value>
                        <div class="ml-3">
                          <span class="content"
                            >追加グローバルIP数
                            {{ putItem.numberOfAddGlobalIpAddress }} 個</span
                          >
                          <div
                            v-for="(item, index) in globalIpAddressList"
                            :key="index"
                          >
                            <span class="content">{{
                              item.globalIpAddress
                            }}</span>
                          </div>
                          <div
                            v-for="i in putItem.numberOfAddGlobalIpAddress"
                            :key="i"
                          >
                            <span class="content"
                              >設定完了後にIPが払い出されます</span
                            >
                          </div>
                        </div>
                      </template>
                    </app-label-group>
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="M365経路制御オプション"
                      :value="$filter.enumTo(putItem.isMicrosoft365, 'on_off')"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="状態"
                      :value="$filter.enumTo(selectedItem.status, 'status')"
                    />
                  </v-col>
                </v-row>
                <!--  契約情報        -->
                <v-row>
                  <v-col>
                    <h3>契約情報</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group
                      label="契約者名"
                      :value="
                        $filter.emptyTo(
                          selectedItem.contractInfo.contractor,
                          '-'
                        )
                      "
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="メールアドレス"
                      :value="selectedItem.contractInfo.email"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="エンドユーザ名"
                      :value="selectedItem.contractInfo.endUserName"
                    />
                  </v-col>
                </v-row>
                <!--  保守連絡先情報        -->
                <v-row>
                  <v-col>
                    <h3>保守連絡先情報</h3>
                  </v-col>
                </v-row>
                <v-row class="px-4">
                  <v-col cols="4">
                    <app-label-group
                      label="会社名"
                      :value="putItem.maintenance.company"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="部署名"
                      :value="putItem.maintenance.department"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="担当者名"
                      :value="putItem.maintenance.name"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="電話番号"
                      :value="putItem.maintenance.phone"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-label-group
                      label="メールアドレス"
                      :value="putItem.maintenance.email"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <!-- prettier-ignore  -->
                  <v-col>
                                <!-- eslint-disable-next-line vue/no-mutating-props -->
                                <validation-provider name="note" v-model="putItem.note"
                                                     label="オーダー備考"
                                                     :rules="{ max: { length: 200 } }"
                                                     v-slot="{ componentField, errorMessage, meta }"
                                >
                                  <app-badge
                                      item="オーダー備考"
                                      :msg="
                                                  $filter.message('info_max_length', {
                                                    maxLength: '200',
                                                  })
                                                "
                                      :isRequired="false"
                                      placement="end"
                                  />
                                  <app-form-input
                                      v-bind="componentField"
                                      :error-messages="errorMessage"
                                      :field-meta="meta"
                                  />
                                </validation-provider>
                              </v-col>
                </v-row>
              </v-container>

              <div class="d-flex justify-center">
                <v-checkbox
                  hide-details
                  v-model="accepted"
                  label="契約(料金変更)に関わる操作を実施します。"
                ></v-checkbox>
              </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn
                  type="submit"
                  variant="flat"
                  color="primary"
                  :disabled="!accepted"
                  >はい
                </v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >いいえ
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  Type4Service,
  Type4ServicePutRequest,
  GlobalIpAddress,
} from "@/apis/ContractChangeType4Api";
import { VueFinalModal } from "vue-final-modal";
import AppLabelGroup from "@/components/AppLabelGroup.vue";
import type { NonNullableProperty } from "@/shims-vue";

export default defineComponent({
  name: "InternetType4ContractModifyConfirm",
  components: { AppLabelGroup },
  props: {
    selectedItem: {
      type: Object as PropType<Type4Service>,
      required: true,
    },
    putItem: {
      type: Object as PropType<
        Type4ServicePutRequest &
          NonNullableProperty<Pick<Type4ServicePutRequest, "maintenance">>
      >,
      required: true,
    },
    globalIpAddressList: {
      type: Array as PropType<GlobalIpAddress[]>,
      required: true,
    },
  },
  data() {
    return {
      accepted: false,
      user: this.$store.state.user,
    };
  },
  methods: {
    /** 「はい」選択時の挙動 */
    submit() {
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
